import { DebugService } from '../../../shared/services/debug.service.js';
import {
  REFI_CREDITPULL_CONST,
  REFI_PREQUAL_CONST,
} from '../../../shared/constants/app.constants.js';

class _CookieService {
  constructor() {
    this.debug = new DebugService('_CookieService');
  }

  getCookie(key) {
    return document.cookie
      ?.split('; ')
      ?.find((row) => row.startsWith(key))
      ?.split('=')[1];
  }

  setCookie(key, value, expirationDate) {
    document.cookie = `${key}=${
      value || ''
    }; expires=${expirationDate}; path=/`;
  }

  removeCookie(key) {
    if (this.getCookie(key)) {
      document.cookie = `${key}=;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
    }
  }

  get pfci() {
    return this.getCookie(REFI_CREDITPULL_CONST.REFI_CI_KEY);
  }

  set pfci(value) {
    const date = new Date();
    date.setDate(date.getDate() + 30);
    this.setCookie(REFI_PREQUAL_CONST.COOKIE_KEYS.pfci, value, date);
  }
}

export const CookieService = new _CookieService();
